import { Box, Button } from "@mui/material";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

function NftCollectionForm() {
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const collectionId = useParams();
  const [nftMintingInputFields, setNftMintingInputFields] = useState({
    contractAddress: "",
    functionName: "",
    abi: "",
    blockchain: "",
  });

  const [configuredArguments, setConfiguredArguments] = useState([]);
  const [functionArguments, setArguments] = useState([]);
  const onHandleNftMintingInputChange = (event) => {
    const { name, value } = event.target;
    setNftMintingInputFields((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  const onHandleArguments = (index, event) => {
    const { name, value } = event.target;

    const newFunctionArguments = [...functionArguments];
    newFunctionArguments[index] = value;
    setArguments(newFunctionArguments);
  };

  function handleAddClick() {
    const newFunctionArguments = [...functionArguments];

    newFunctionArguments.push("");

    setArguments(newFunctionArguments);
  }

  async function submitNftMintingForm(event) {
    event.preventDefault();

    if (
      nftMintingInputFields.contractAddress &&
      nftMintingInputFields.functionName &&
      nftMintingInputFields.abi &&
      nftMintingInputFields.blockchain
    ) {
      //   setLoadingScreen(true);
      await axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/api/nft-minting-info`,
          { formValues: nftMintingInputFields, arguments: functionArguments },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          //   setLoadingScreen(false);

          if (res.data.status) {
            swal({
              text: res.data.message,
              icon: "success",
            });

            navigate("/nft-minting");
            setNftMintingInputFields({
              contractAddress: "",
              functionName: "",
              abi: "",
              blockchain: "",
            });
          } else {
            swal({
              text: res.data.message,
              icon: "warning",
            });
          }
        })
        .catch((err) => {
          //   setLoadingScreen(false);

          swal({
            text: err.response.data.errorMessage,
            icon: "error",
          });
        });
    } else {
      swal({
        text: "Add proper parameter first!",
        icon: "warning",
      });
    }
  }

  async function submitEditedNftMintingForm(e) {
    e.preventDefault();

    if (
      nftMintingInputFields.contractAddress &&
      nftMintingInputFields.functionName &&
      nftMintingInputFields.abi &&
      nftMintingInputFields.blockchain
    ) {
      // var isPermitted = true;
      // if (configuredArguments.length !== functionArguments.length) {
      //   isPermitted = await swal({
      //     title: "Are you sure?",
      //     text: "You are modifying the number of arguments for the minting function, which will lead to the deletion of all the configured NFTs in your collection's dashboard.",
      //     icon: "warning",
      //     buttons: true,
      //     dangerMode: true,
      //   }).then((willDelete) => {
      //     if (willDelete) {
      //       return true;
      //     }
      //   });
      // }
      // if (!isPermitted) {
      //   return;
      // }
      await axios
        .put(
          `${process.env.REACT_APP_BASE_URL}/api/nft-minting-info`,
          {
            formValues: nftMintingInputFields,
            arguments: functionArguments,
            collectionId: collectionId.id,
          },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          //   setLoadingScreen(false);

          if (res.data.status) {
            swal({
              text: res.data.message,
              icon: "success",
            });

            navigate("/nft-minting");
            setNftMintingInputFields({
              contractAddress: "",
              functionName: "",
              abi: "",
              blockchain: "",
            });
          } else {
            swal({
              text: res.data.message,
              icon: "warning",
            });
          }
        })
        .catch((err) => {
          //   setLoadingScreen(false);

          swal({
            text: err.response.data.errorMessage,
            icon: "error",
          });
        });
    } else {
      swal({
        text: "Add proper parameter first!",
        icon: "warning",
      });
    }
  }

  async function onload() {
    try {
      await axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/api/nft-minting/collection-details?collectionId=${collectionId.id}`,
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (res.data.status) {
            const collectionDetails = res.data.collectionDetails;
            setIsEdit(true);
            setNftMintingInputFields({
              contractAddress: collectionDetails.contractAddress,
              functionName: collectionDetails.functionName,
              abi: collectionDetails.abi,
              blockchain: collectionDetails.blockchain,
            });
            setArguments(collectionDetails.argument);
            setConfiguredArguments(collectionDetails.argument);
          } else {
            navigate("nft-minting");
          }
        });
    } catch (error) {
      navigate("nft-minting");
    }
  }

  function removeField(i) {
    let newFunctionArguments = [...functionArguments];
    newFunctionArguments.splice(i, 1);
    setArguments(newFunctionArguments);
  }

  useEffect(() => {
    if (collectionId.id) {
      onload();
    }
  }, []);
  return (
    <Box m="20px">
      <div style={{ marginBottom: "30px" }}>
        <Header title="Add Collection" subtitle="Fill the required field " />
      </div>
      <Box
        variant="gradient"
        borderRadius="lg"
        shadow="lg"
        opacity={1}
        p={3}
        textAlign="left"
        sx={{
          bgcolor: "white",
          boxShadow: 4,
        }}
      >
        <form
          onSubmit={isEdit ? submitEditedNftMintingForm : submitNftMintingForm}
        >
          <div
            style={{
              gap: "2%",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              marginBottom: "12px",
            }}
          >
            <fieldset className="login-form input-fullwidth">
              <label
                htmlFor="contractAddress"
                id="contractAddressLabel"
                className="login-form-label"
              >
                Contract Address
                <div className="input-div-css-1 input-fullwidth input-div-css-2">
                  <div className="input-div-css-3">
                    <input
                      required
                      name="contractAddress"
                      aria-labelledby="contractAddressLabel"
                      type="text"
                      className="input-custom-css input-custom-height"
                      id="contractAddress"
                      aria-invalid="false"
                      value={nftMintingInputFields.contractAddress}
                      onChange={(e) => onHandleNftMintingInputChange(e)}
                    ></input>
                  </div>
                </div>
              </label>
            </fieldset>
            <fieldset className="login-form input-fullwidth">
              <label
                htmlFor="blockchain"
                id="blockchainLabel"
                className="login-form-label"
              >
                Select Blockchain
                <div className="input-div-css-1 input-div-css-2 input-fullwidth">
                  <div className="input-div-css-3">
                    <select
                      required
                      className="input-custom-css select-input"
                      id="blockchain"
                      aria-labelledby="blockchainLabel"
                      name="blockchain"
                      onChange={(e) => onHandleNftMintingInputChange(e)}
                      value={nftMintingInputFields.blockchain}
                      aria-invalid="false"
                    >
                      <option disabled value="">
                        Select Blockchain
                      </option>
                      <option value="1">Ethereum</option>
                      <option value="11155111">Sepolia</option>
                      <option value="137">Polygon</option>
                      <option value="80001">Polygon Mumbai</option>
                    </select>
                  </div>
                </div>
              </label>
            </fieldset>
          </div>
          <div
            style={{
              marginBottom: "12px",
              gap: "2%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <fieldset
              style={{ width: "49%" }}
              className="login-form input-fullwidth"
            >
              <label
                htmlFor="functionName"
                id="functionNameLabel"
                className="login-form-label"
              >
                Function Name
                <div className="input-div-css-1 input-fullwidth input-div-css-2">
                  <div className="input-div-css-3">
                    <input
                      required
                      name="functionName"
                      aria-labelledby="functionNameLabel"
                      type="text"
                      className="input-custom-css input-custom-height"
                      id="functionName"
                      aria-invalid="false"
                      value={nftMintingInputFields.functionName}
                      onChange={(e) => onHandleNftMintingInputChange(e)}
                    ></input>
                  </div>
                </div>
              </label>
            </fieldset>
          </div>

          <div>
            <label className="login-form-label">Arguments</label>
            <br />

            {functionArguments.map((ele, index) => (
              <div style={{ display: "flex", flexDirection: "row" }}>
                <fieldset
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "49%",
                  }}
                  className="login-form "
                >
                  <label
                    style={{ marginTop: "16px" }}
                    htmlFor="arguments"
                    id="argumentsLabel"
                    className="login-form-label"
                  >
                    {index + 1}
                  </label>
                  <div className="input-div-css-1 input-fullwidth input-div-css-2">
                    <div className="input-div-css-3">
                      <input
                        required
                        name="arguments"
                        aria-labelledby="argumentsLabel"
                        type="text"
                        className="input-custom-css input-custom-height"
                        id="arguments"
                        aria-invalid="false"
                        value={ele}
                        onChange={(e) => onHandleArguments(index, e)}
                      ></input>
                    </div>
                  </div>
                </fieldset>
                <div
                  style={{
                    display: "flex",
                    width: "8%",
                  }}
                >
                  <DeleteIcon
                    className="delete-icon"
                    onClick={(e) => removeField(index, e)}
                    sx={{
                      margin: "auto",

                      marginTop: "15px",
                    }}
                  />
                </div>
              </div>
            ))}
            <Button
              size="small"
              className="custom-color-button"
              variant="contained"
              sx={{
                fontSize: "10px",
                marginBottom: "16px",
                marginTop: functionArguments.length ? "0px" : "16px ",
              }}
              startIcon={<AddIcon />}
              onClick={() => handleAddClick()}
            >
              ADD
            </Button>
          </div>
          <fieldset className="login-form input-fullwidth">
            <label htmlFor="abi" id="abiLabel" className="login-form-label">
              ABI
              {/* <span className="required-field">*</span> */}
              <div className="input-div-css-1 input-fullwidth input-div-css-2">
                <div className="input-div-css-3">
                  <textarea
                    required
                    style={{
                      height: "30vh",
                    }}
                    name="abi"
                    aria-labelledby="abiLabel"
                    type="text"
                    className="input-custom-css"
                    id="abi"
                    aria-invalid="false"
                    value={nftMintingInputFields.abi}
                    onChange={(e) => onHandleNftMintingInputChange(e)}
                  ></textarea>
                </div>
              </div>
            </label>
          </fieldset>
          <Button
            className="custom-color-button"
            sx={{
              fontSize: "15px",
              marginTop: "10px",
            }}
            type="submit"
            variant="contained"
          >
            Submit
          </Button>
        </form>
      </Box>
    </Box>
  );
}

export default NftCollectionForm;
